export const customStyles = {
    placeholder: (provided: any, _state: any) => ({
        ...provided,
        marginLeft: '5px',
    }),
    input: (provided: any, _state: any) => ({
        ...provided,
        marginLeft: '-10px',
    }),
    valueContainer: (provided: any, _state: any) => ({
        ...provided,
        paddingRight: '0',
    }),
    control: (provided: any, _state: any) => ({
        ...provided,
        backgroundColor: '#F2F2F2',
        boxShadow: 'none',
        border: 0,
        borderTopLeftRadius: 4.5,
        borderBottomLeftRadius: 4.5,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
    }),
};

export const customTheme = (theme: any) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary25: '#ffeecc',
        primary: 'hsl(0, 0%, 80%)',
    },
});

export const countryCodeStyles = {
    control: (provided: any, _state: any) => ({
        ...provided,
        backgroundColor: '#F2F2F2',
        boxShadow: 'none',
        borderLeft: 0,
        borderTop: 0,
        borderBottom: 0,
        borderTopLeftRadius: 4.5,
        borderBottomLeftRadius: 4.5,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
    }),
    menu: ({ width, ...css }: any) => ({ ...css }),
};
